import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LeftGnb = () => {
    const navigate = useNavigate();
    let [popup, setPopup] = useState(false);
    let [store, setStore] = useState(false);
    const showPopup = () => {
        setPopup(popup == true ? false : true);
        popup == true ? setStore(false) : setStore(false);
    };
    const showStore = () => {
        setStore(store == true ? false : true);
        store == true ? setPopup(false) : setPopup(false);
    };
    return (
        <>
            <div className="left_gnb_wrapper">
                <img onClick={() => navigate("/")} src="/assets/images/segim_logo.svg" alt="" />
                <ul className="left_gnb_menu_list">
                    <li onClick={showPopup} >
                        <img src="/assets/images/icon_plus.svg" alt="" />
                        <h1>바로가기 만들기</h1>
                    </li>
                    <li onClick={showStore}>
                        <img src="/assets/images/icon_plus.svg" alt="" />
                        <h1>스토어</h1>
                    </li>
                </ul>
            </div>
            {
                popup == true ? <Popup popup={showPopup} /> : null
            }
            {
                store == true ? <Store store={showStore} /> : null
            }
        </>
    );
};



function Store(props) {
    fetch(`https://api.segimedu.com/api/epamus/searchIntranetApp`)
        .then(function (res) {
            return res.json();
        })
        .then(function (data) {
            data.data.map((item, idx) => {
                document.querySelectorAll(".searchBody")[0].insertAdjacentHTML("beforeend", `<tr id = ${item.id} class = "store_list_row"><td><input class="store_checkbox" type="checkbox" /></td><td>${idx}</td><td class="appName" >${item.name}</td><td>${item.url}</td><td>${item.author}</td><td><button class = "store_delete">삭제</button></td></tr>`); document.querySelectorAll("table tr")[idx].addEventListener("click", (e) => {
                    if (e.target.tagName !== "INPUT" && e.target.tagName !== "BUTTON") {
                        const storeCheck = document.querySelectorAll("input[type = 'checkbox']")[idx - 1];
                        storeCheck.checked == true ? storeCheck.checked = false : storeCheck.checked = true;
                    }
                });
                document.querySelectorAll(".store_delete")[idx].addEventListener("click", ()=>{
                    alert(`${idx}번째 항목이 삭제되었습니다`);
                });
            });

        })

    return (
        <>
            <div className="store_wrap" onClick={props.store}></div>
            <div className="store">
                <div className="store_close" onClick={props.store}><span>X</span></div>
                <h2>스토어</h2>
                <form className="search_wrap">
                    <input type="text" onChange={filter} className="store_search" id="store_search" placeholder="앱 이름을 입력해주세요" /><img src="../assets/images/icon_search.png" alt="icon" />
                </form>
                <div className="table_wrap">
                    <table>
                        <thead>
                            <tr>
                                <th>선택</th><th>순서</th><th>앱 이름</th><th>URL</th><th>게시자 이름</th><th>항목 삭제</th>
                            </tr>
                        </thead>
                        <tbody className="searchBody">

                        </tbody>
                    </table>
                </div>
                <div className="add_store">선택항목 추가하기</div>
            </div>
        </>
    )
}

function filter() {
    let value = document.querySelectorAll(".store_search")[0].value;
    const item = document.querySelectorAll(".store_list_row");

    for (let i = 0; i < item.length; i++) {
        let name = item[i].querySelectorAll(".appName");
        if (name[0].innerHTML.indexOf(value) > -1) {
            item[i].style.display = "";
        } else {
            item[i].style.display = "none";
        }
    }
}




function Popup(props) {
    const create = () => {
        const uploadCheckbox = document.querySelectorAll(".upload")[0];
        if (document.querySelectorAll(".redirect_name")[0].value.length > 0 && document.querySelectorAll(".redirect_url")[0].value.length > 0 && document.querySelectorAll(".publisher")[0].value.length > 0 && document.querySelector("#file").getAttribute("img_src") != null) {

            const originData = JSON.parse(localStorage.getItem("localAppObj"));
            const data = {
                redirect_name: document.querySelectorAll(".redirect_name")[0].value,
                redirect_url: document.querySelectorAll(".redirect_url")[0].value,
                publisher: document.querySelectorAll(".publisher")[0].value,
                is_save: uploadCheckbox == uploadCheckbox.checked ? true : false,
                img_src: document.querySelector("#file").getAttribute("img_src")
            }
            if (originData) {
                originData.push(data);
                localStorage.setItem("localAppObj", JSON.stringify(originData));
            } else {
                localStorage.setItem("localAppObj", JSON.stringify([data]));
            }

            if (uploadCheckbox.checked) {

                let formData = new FormData();
                formData.append("name", data.redirect_name);
                formData.append("url", data.redirect_url);
                formData.append("author", data.publisher);
                fetch(`https://api.segimedu.com/api/epamus/uploadIntranetApp`, {
                    method: "POST",
                    body: formData,
                })
                    .then(function (res) {
                        return res.json();
                    })
                    .then(function (json) {
                        if (json.success == true) {
                            console.log(formData);
                        }
                    })
            }
            window.location.reload(true);
        } else if (document.querySelectorAll(".redirect_name")[0].value.length == 0) {
            alert("바로가기의 이름을 입력해주세요");
        } else if (document.querySelectorAll(".redirect_url")[0].value.length == 0) {
            alert("URL을 입력해주세요");
        } else if (document.querySelectorAll(".publisher")[0].value.length == 0) {
            alert("게시자 이름을 입력해주세요")
        } else {
            alert("아이콘을 업로드해주세요");
        }
    }




    const handleFiles = (e) => {
        const fileInput = document.querySelector("#file");
        const selectedFile = [...fileInput.files];
        const fileReader = new FileReader();

        fileReader.readAsDataURL(selectedFile[0]);

        fileReader.onload = function () {
            //fileReader.result -> 파일리더로 읽은 이미지의 SRC (base64)
            document.querySelector("#file").setAttribute("img_src", fileReader.result);
        };

        document.querySelectorAll(".upload-name")[0].value = document.querySelector("#file").files[0].name;
    };


    return (
        <>
            <div className="popup_wrap" onClick={props.popup}></div>
            <div className="popup">
                <h2>바로가기 만들기</h2>
                <ul>
                    <li>
                        <p>바로가기 이름</p>
                        <input className="redirect_name" type="text" placeholder="바로가기 이름을 입력하세요" />
                    </li>
                    <li>
                        <p>바로가기 url</p>
                        <input className="redirect_url" type="text" placeholder="URL을 입력하세요" />
                    </li>
                    <li>
                        <p>만든이 이름</p>
                        <input className="publisher" type="text" placeholder="게시하는 분 이름을 입력해주세요" />
                    </li>
                    <li>
                        <p>아이콘 업로드</p>
                        <form>
                            <input readOnly className="upload-name" />
                            <label htmlFor="file">업로드</label>
                            <input onChange={handleFiles} type="file" id="file" />
                        </form>
                    </li>
                    <li>
                        <input type="checkbox" className="upload" /> <span>스토어에 이 바로가기를 업로드 합니다</span>
                    </li>
                </ul>
                <div className="create" onClick={create}><span>바로가기 생성</span></div>
                <div className="close" onClick={props.popup}><span>X</span></div>
            </div>
        </>
    )
}

export default LeftGnb;
